import { getConfig, launchSpirometry } from '@/core/classes/MedconnectDevicesAPI'
import { DEVICES, MedconnectDevicesConfig } from '@/constants/medconnect-devices-types'
import { Chip, Grid, Typography } from '@mui/material'
import colors from '@/assets/scss/_themes-vars.module.scss'
import { useAppSelector } from '@/redux/rootReducer'
import { selectConsultationById } from '@/redux/reducers/consultation.reducer'
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import { Box } from '@mui/system'
import { LoadingButton } from '@mui/lab'
import { buildDevicePatient } from '@/utils/medconnectDevices/patientBiometrics'

type MIRSpirometryProps = {
  consultationId?: string
}
export function MIRSpirometry({ consultationId }: Readonly<MIRSpirometryProps>) {
  const consultation = useAppSelector((state) => (consultationId ? selectConsultationById(state, consultationId) : undefined))

  const { t } = useTranslation()

  const [loading, setLoading] = useState<boolean>(false)

  const startExam = () => {
    const patient = buildDevicePatient(consultation)
    const showLoaderAndReset = () => {
      setLoading(true)
      setTimeout(() => {
        setLoading(false)
      }, 1000)
    }

    if (!patient) return
    launchSpirometry({
      patient,
    })
    showLoaderAndReset()
  }
  const [config, setConfig] = useState<MedconnectDevicesConfig | undefined>(undefined)
  useEffect(() => {
    const handleConfig = async () => {
      const config = await getConfig()
      if (!config) return
      setConfig(config)
    }
    handleConfig()
  }, [])

  if (!config?.Devices) return null

  if (config?.Devices.filter((device) => device.name === DEVICES.MIR_SPIROMETRY).length === 0) {
    return null
  }

  return (
    <Grid item xs={12} sm={6}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <Typography variant="h6" component="div" sx={{ color: colors.gray900, fontSize: '16px', fontWeight: 500, lineHeight: '24px' }}>
          {t(`component.ui.deviceCard.deviceLabels.${DEVICES.MIR_SPIROMETRY}`)}
        </Typography>
        <Chip color="success" label={t(`component.ui.deviceCard.installed.label`)} variant="filled" size="small" />
      </Box>
      <Box>
        <LoadingButton
          onClick={startExam}
          color="primary"
          disableElevation
          loading={loading}
          variant="contained"
          size="small"
        >
          {t('component.ui.deviceCard.startSpirometry.label')}
        </LoadingButton>
      </Box>
    </Grid>
  )
}
